<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center py-4">
      <div class="spinner-border spinner-border-sm" role="status"></div>
    </div>

    <div v-if="!loading && file">
      <div v-if="file.mime_type === 'application/pdf' && pdfSrc">
        <vue-pdf-embed :source="pdfSrc" />
      </div>
      <div v-else-if="file.mime_type && file.mime_type.includes('image/') && file.base64">
        <img :src="'data:' + file.mime_type + ';base64,' + file.base64" class="w-100" alt="" />
      </div>
      <div v-else-if="isOfficeFile">
        <div class="o365-iframe-wrapp">
          <iframe
              :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + file.view_url"
              frameborder="0"
              width="100%"
              height="100%"
              class="o365-iframe"
          ></iframe>
        </div>
      </div>
      <div v-else-if="!file.base64 && !isOfficeFile" class="alert alert-warning text-center mt-3">
        <span>{{ $t('file.previewNotAvailable') }}</span>
      </div>
    </div>

    <div v-if="message" class="alert alert-danger text-center mt-3">
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
import http from '@/http';
import VuePdfEmbed from 'vue-pdf-embed';

export default {
  components: {
    VuePdfEmbed,
  },

  props: ['fileContentUrl'],

  mounted() {
    this.getFileContent();
  },

  data() {
    return {
      file: null,
      loading: true,
      message: null,
    };
  },

  computed: {
    pdfSrc() {
      if (this.file && this.file.mime_type === 'application/pdf' && this.file.base64) {
        return { data: window.atob(this.file.base64) };
      }
      return null;
    },

    isOfficeFile() {
      const officeMimes = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-excel',
        'application/msword',
      ];
      return this.file && officeMimes.includes(this.file.mime_type);
    },
  },

  methods: {
    getFileContent() {
      http.get(this.fileContentUrl).then((response) => {
        const checked = response.data.checksum ? this.checkChecksum(response.data) : true;
        if (checked) {
          this.file = response.data;
        } else {
          this.message = this.$t('file.checksumNotMatch');
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    async checkChecksum(file) {
      const cleaned = file.base64.includes(',') ? file.base64.split(',')[1] : file.base64;
      const binary = atob(cleaned);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      const hashBuffer = await crypto.subtle.digest('SHA-256', bytes);
      const hash = Array.from(new Uint8Array(hashBuffer))
          .map(b => b.toString(16).padStart(2, '0')).join('');
      return hash === file.checksum;
    },
  },
};
</script>